import React from "react";
import { Modal, Row, Col } from "antd";
import { useSelector } from "react-redux";

const Policy = ({ open, data, handleClose }) => {
  const selectedLanguage = useSelector((state) => state.selectedLanguage);
  const { terms_title = {}, terms_description_text = {} } = data;
  return (
    <Modal
      onCancel={handleClose}
      closable={true}
      title={
        <span className="font-helvetica-neue-medium">
          {terms_title[selectedLanguage]}
        </span>
      }
      visible={open}
      open={open}
      footer={null}
    >
      <Row>
        <Col xs={24}>
          <div
            className="policy_content"
            dangerouslySetInnerHTML={{
              // __html: terms_description_text[selectedLanguage],
              __html: terms_description_text,
            }}
          ></div>
        </Col>
      </Row>
    </Modal>
  );
};

export default Policy;
